module.exports = "/9/2-structs-and-pointer/index.html.3dac4346cb7783e552949ccfe8b270fd.json"


/*****************
 ** WEBPACK FOOTER
 ** ./content/generated/33521.md
 ** module id = 580
 ** module chunks = 0
 **/